import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const EMAIL_STATUS = {
  sent: { label: "Envoyé", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  delivered: { label: "Délivré", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  opened: { label: "Ouvert", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  clicked: { label: "Cliqué", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  bounced: { label: "Rejeté", cls: "bg-red-50 text-red-700 border-red-200" },
  delayed: { label: "Différé", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  complained: { label: "Spam", cls: "bg-red-50 text-red-700 border-red-200" },
};

export function EmailStatusBadge({ status }) {
  if (!status) return null;
  const s = EMAIL_STATUS[status] || EMAIL_STATUS.sent;
  return (
    <span data-testid={`email-status-${status}`}
      className={`inline-block text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 border rounded-full ${s.cls}`}>
      {s.label}
    </span>
  );
}

export default function CRM() {
  const navigate = useNavigate();
  const [acts, setActs] = useState([]);
  useEffect(() => { api.get("/activities").then((r) => setActs(r.data)); }, []);
  const icons = { appel: "📞", email: "✉️", reunion: "🤝", note: "📝" };

  return (
    <div>
      <header className="h-16 px-8 flex items-center border-b border-border bg-white sticky top-0 z-10">
        <h1 className="font-head font-bold text-xl">CRM Négociation</h1>
      </header>
      <div className="p-8 max-w-3xl">
        <div className="overline text-muted-foreground mb-4">Historique complet · {acts.length} interactions</div>
        {acts.length === 0 && <div className="text-sm text-muted-foreground">Aucune interaction. Enregistrez des appels, emails et réunions depuis la fiche d'un cabinet (onglet CRM).</div>}
        <div className="relative space-y-4">
          {acts.map((a) => (
            <div key={a.id} className="bg-white border border-border p-4 flex gap-3" data-testid="crm-global-activity">
              <div className="text-lg">{icons[a.type] || "📝"}</div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-sm">{a.title}</span>
                  <span className="overline text-muted-foreground">{new Date(a.date).toLocaleDateString("fr-FR")}</span>
                </div>
                {a.content && <p className="text-sm text-muted-foreground mt-1">{a.content}</p>}
                <div className="flex items-center gap-2 mt-1.5">
                  <button onClick={() => a.company_id && navigate(`/cabinet/${a.company_id}`)} className="overline text-primary hover:underline">
                    {a.company_nom || "—"} · {a.type} · {a.author}
                  </button>
                  {a.type === "email" && <EmailStatusBadge status={a.email_status} />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
